import { render, staticRenderFns } from "./edit_shifuinfo.vue?vue&type=template&id=11aaea32&scoped=true&"
import script from "./edit_shifuinfo.vue?vue&type=script&lang=js&"
export * from "./edit_shifuinfo.vue?vue&type=script&lang=js&"
import style0 from "./edit_shifuinfo.vue?vue&type=style&index=0&id=11aaea32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11aaea32",
  null
  
)

export default component.exports